var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxPreparers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.273 7.15904H9.20466V4.09106H7.1591V7.15904H4.09113V9.2046H7.1591V12.273H9.20466V9.2046H12.273V7.15904ZM17.7274 7.15904H25.9092V9.2046H17.7274V7.15904ZM6.01178 25.4338L8.18151 23.2644L10.3512 25.4338L11.7976 23.9878L9.62787 21.8184L11.7976 19.6491L10.3512 18.2027L8.18151 20.3721L6.01178 18.2027L4.56579 19.6491L6.73515 21.8184L4.56579 23.9878L6.01178 25.4338Z",
    fill: "#1E4387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V30H17.7274V27.2728H16.3638V16.3638H27.2728V17.7274H30V0H0ZM2.72754 2.72754H13.6366V13.6366H2.72754V2.72754ZM13.6366 27.2728H2.72754V16.3638H13.6366V27.2728ZM27.2728 13.6366H16.3638V2.72754H27.2728V13.6366Z",
    fill: "#1E4387"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2076 20.6873V26.8549L24.549 29.9389L29.8904 26.8549V20.6873L24.549 17.6033L19.2076 20.6873ZM26.822 21.2775L24.5486 22.5897L22.2756 21.2775L24.549 19.965L26.822 21.2775ZM21.2532 23.049L23.5262 24.3612V26.9862L21.2532 25.674V23.049ZM25.5718 26.9865V24.3612L27.8452 23.049V25.674L25.5718 26.9865Z",
    fill: "#1E4387"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxPreparers);
export default __webpack_public_path__ + "static/media/tax-preparers.e4682aa861b92ecca21121d9acd7bf43.svg";
export { ForwardRef as ReactComponent };